export const camelCasefy = (string) => {
  const _words = string?.split(" ");

  const _camelCased = _words?.map((el, index) => {
    if (index === 0) return el?.charAt(0)?.toLocaleLowerCase() + el?.slice(1);
    return el.charAt(0).toUpperCase() + el?.slice(1);
  });

  return _camelCased?.join("");
};

export const thousandsify = (num) =>
  Math.abs(num) > 999 ? (num / 1000).toFixed(2) + "k" : num;
